/*
 * @Author: Jhonsem
 * @Date: 2021-01-06 17:15:39
 * @Last Modified by: jhonsem
 * @Last Modified time: 2021-03-23 10:38:32
 *
 * 登陆的cookie在登陆的过程中单独来维护，如何判断登陆成功，是取出ds_user_id是否存在
 * 在登陆过程中维护一个cookie,登陆成功后将这个cookie更新到persisi_cookie中去
 * 登陆过程中的cookie都是用此处的cookie来使用的
 */

import { formatCookie } from "@/api/utils/api_helpers";

interface CookieMap {
  domain?: string;
  value: string;
  name: string;
  path?: string;
  expiresAt?: number;
  secure?: boolean;
  httpOnly?: string;
  hostOnly?: boolean;
  persistent?: boolean;
}

class InsLoginCookieHandle {
  public cookieHandle: any;
  public cookieKey: string | number;

  constructor() {
    this.cookieHandle = {};
    this.cookieKey = "";
  }

  /**
   * 在登陆的开始阶段重置cookie单例
   * @param key
   */
  public createCookie(key: string | number) {
    if (this.cookieKey !== key) {
      this.cookieKey = key;
      this.cookieHandle = {};
    }
  }

  /**
   * 登陆过程中去更新cookie单例
   * @param updateCookies
   */
  public updateCookie(updateCookies: CookieMap[]) {
    const updateCookieMap: any = {};
    updateCookies.forEach((cookie: any) => {
      cookie && (updateCookieMap[cookie.name] = cookie.value);
    });

    this.cookieHandle = {
      ...this.cookieHandle,
      ...updateCookieMap
    };
  }

  public getCookie() {
    return formatCookie(this.cookieHandle);
  }

  public clearCookie() {
    this.cookieKey = "";
    this.cookieHandle = {};
  }

  public getCookieMap() {
    return this.cookieHandle;
  }
}

export default new InsLoginCookieHandle();
